import PunchoutHidden from './PunchoutHidden';

export default PunchoutHidden;
